import { useQuery } from '@tanstack/react-query';
import { getSessionStatus } from '../api/beachvision';

/**
 * Polls lightweight session status for the processing screen.
 */
export function useSessionStatus(sessionId, pollMs = 3000) {
  return useQuery({
    queryKey: ['beachvision', 'sessionStatus', sessionId],
    queryFn: () => getSessionStatus(sessionId),
    enabled: Boolean(sessionId),
    refetchInterval: pollMs,
  });
}
